import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Stack, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormTextField } from "../../../../../../../components/fields";
import { IFormValues } from "../../../../../types";

const AdditionalDriversDetails = () => {

    const { t } = useTranslation(['booking']);

    const additionalDriversDetails = useWatch<IFormValues, 'additionalDriversDetails'>({
        name: 'additionalDriversDetails'
    });

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Typography variant="h5">
                        {t('label.additionalDriversDetails')}
                    </Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    {additionalDriversDetails.map((ad, i) => (
                        <Grid key={i} container item xs={12} rowSpacing={1} columnSpacing={3}>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name={`additionalDriversDetails.${i}.id`}
                                    label={t('label.id')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name={`additionalDriversDetails.${i}.firstName`}
                                    label={t('label.firstName')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name={`additionalDriversDetails.${i}.lastName`}
                                    label={t('label.lastName')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name={`additionalDriversDetails.${i}.email`}
                                    label={t('label.email')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name={`additionalDriversDetails.${i}.webCheckIn`}
                                    label={t('label.webCheckIn')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>

                            {   i !== additionalDriversDetails.length -1 &&
                                <Divider orientation={"horizontal"} style={{width:'100%' }} sx={{mt: 4, mb: 3, marginLeft: '12px'}} textAlign={"center"} />
                            }
                        </Grid>
                    ))}
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
};

export default AdditionalDriversDetails;
